import { render, staticRenderFns } from "./MyWorkList.vue?vue&type=template&id=edfc1238&scoped=true&"
import script from "./MyWorkList.vue?vue&type=script&lang=js&"
export * from "./MyWorkList.vue?vue&type=script&lang=js&"
import style0 from "./MyWorkList.vue?vue&type=style&index=0&id=edfc1238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfc1238",
  null
  
)

export default component.exports